import { Directive, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmBreadcrumb]',
  host: {
    role: 'navigation',
    '[class]': '_computedClass()',
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class HlmBreadcrumb {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  public readonly ariaLabel = input<string>('breadcrumb', { alias: 'aria-label' });

  protected readonly _computedClass = computed(() => hlm(this.userClass()));
}
